document.addEventListener("DOMContentLoaded", function () {
  const minusBtn = document.getElementById("qty-minus");
  const plusBtn = document.getElementById("qty-plus");
  const quantity = document.getElementById("qty-input");
  const input = document.querySelector("[name='denomination_region']");
  const radioGroup = document.getElementById("denomination-radio-group");

  let initialLoad = true;

  if (!input || !radioGroup) return;

  if (minusBtn && plusBtn) {
    minusBtn.addEventListener("click", function () {
      var value = parseInt(quantity.value, 10) || 1;
      if (value > 1) {
        quantity.value = value - 1;
        quantity.dispatchEvent(new Event("change"));
      }
    });

    plusBtn.addEventListener("click", function () {
      var value = parseInt(quantity.value, 10) || 1;
      quantity.value = value + 1;
      quantity.dispatchEvent(new Event("change"));
    });
  }

  let selectedCountryObject = null;

  function renderRadiosForCountry(countryName) {
    // Filter productVariants for the selected country using option1
    const matchingVariants = productVariants.filter(
      (variant) => variant.option1 === countryName
    );

    selectedCountryObject = variantCountries.find(
      (country) => country.name === countryName
    );

    if (!matchingVariants.length) {
      radioGroup.innerHTML =
        "<div style='color: #d9534f; font-size: 13px;'>No denominations available for this country.</div>";
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const variationIdFromUrl = urlParams.get("variant");
    const variationIdFromUrlNum = variationIdFromUrl
      ? parseInt(variationIdFromUrl, 10)
      : null;

    let prefferedDenomination = JSON.parse(
      localStorage.getItem("prefferedDenominations") || "{}"
    )[productHandle];

    prefferedDenomination =
      prefferedDenomination && parseInt(prefferedDenomination, 10);

    const variantIdToSetBy = variationIdFromUrlNum || prefferedDenomination;

    let matchingVariant;

    if (variantIdToSetBy) {
      matchingVariant = matchingVariants.find(
        (variant) => variant.id === variantIdToSetBy
      );
    }

    // Render a radio for each matching variant
    radioGroup.innerHTML = matchingVariants
      .sort((a, b) => {
        const numberA = a.price;
        const numberB = b.price;

        if (numberA < numberB) return -1;
        if (numberA > numberB) return 1;
        return 0;
      })
      .map(
        (variant, index) => `
      <label>
        <input
          type="radio"
          name="id"
          class="custom-giftcard-denomination-input"
          value="${variant.id}" 
          ${matchingVariant?.id === variant.id || index === 0 ? "checked" : ""}
          data-currency="${variant.currency}" data-price="${variant.price}">
          <div class="custom-giftcard-value">
          ${variant.option2}
        </div>
      </label>
    `
      )
      .join("");

    initiatePriceChangeListeners();

    if (initialLoad) {
      // On initial load, we hide the skeletons and show the select wrappers
      const selectWrapperSkeleton = document.getElementById(
        "custom-giftcard-select-wrapper-skeleton"
      );
      const selectWrapper = document.getElementById(
        "custom-giftcard-select-wrapper"
      );
      selectWrapperSkeleton.classList.remove("skeleton-show");
      selectWrapper.style.display = "block";
      initialLoad = false;
    }

    // After rendering the radio buttons
    const defaultChecked = document.querySelector(
      ".custom-giftcard-denomination-input:checked"
    );
    if (defaultChecked) {
      // Create and dispatch the change event
      const event = new Event("change", { bubbles: true });
      defaultChecked.dispatchEvent(event);
    }
  }

  input.addEventListener("change", function () {
    renderRadiosForCountry(this.value);
  });

  function setInitialSelection() {
    let prefferedDenomination = JSON.parse(
      localStorage.getItem("prefferedDenominations") || "{}"
    )[productHandle];

    prefferedDenomination =
      prefferedDenomination && parseInt(prefferedDenomination, 10);

    let countryClicked = false;
    const urlParams = new URLSearchParams(window.location.search);
    const variationIdFromUrl = urlParams.get("variant");
    const variationIdFromUrlNum = variationIdFromUrl
      ? parseInt(variationIdFromUrl, 10)
      : null;

    const variantIdToSetBy = variationIdFromUrlNum || prefferedDenomination;

    if (variantIdToSetBy) {
      const selectedVariant = productVariants.find(
        (variant) => variant.id === variantIdToSetBy
      );

      if (selectedVariant) {
        const countryItemToClick = document.querySelector(
          `#CustomGiftCardForm #dropdown-v2 a[data-value="${selectedVariant.option1}"]`
        );

        if (countryItemToClick) {
          countryItemToClick.click();
          countryClicked = true;
        }
      }
    }

    if (!countryClicked) {
      renderRadiosForCountry(input.value);
    }
  }

  setInitialSelection();

  function updateConvertedPrice() {
    const selectedRadio = document.querySelector('input[name="id"]:checked');

    if (!selectedRadio) return;

    const priceSpan = document.getElementById("converted-price");

    const itemPrice = selectedRadio.dataset.price; // price in cents
    const qty = parseInt(quantity?.value || 1, 10) || 1;

    const convertedCents = Math.round(parseFloat(itemPrice) * qty);
    const formatted = (convertedCents / 100).toFixed(2);

    priceSpan.textContent = ` ${currencySymbol}${formatted}`;
  }

  function initiatePriceChangeListeners() {
    // Listen for changes
    document.querySelectorAll('input[name="id"]').forEach((radio) => {
      radio.addEventListener("change", (e) => {
        localStorage.setItem(
          "prefferedDenominations",
          JSON.stringify({
            ...JSON.parse(
              localStorage.getItem("prefferedDenominations") || "{}"
            ),
            [productHandle]: e.target.value,
          })
        );
        updateConvertedPrice();
      });
    });
  }

  // Also update when quantity changes
  quantity?.addEventListener("change", updateConvertedPrice);

  // Listen for custom paymentCurrencyChanged event
  window.addEventListener("paymentCurrencyChanged", updateConvertedPrice);
});
